import React from 'react';
import { Field } from 'formik';
import { FieldInput } from '@magoosh/lib/formik_inputs/field_input/template';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import { months, years } from '../utils';
import cx from 'classnames';
import style from './style.module.scss';
import { BulkPaymentFormGroupProps } from '../types';

export const BulkPaymentFormGroup: React.FC<BulkPaymentFormGroupProps> = ({ errors }) => (
  <div className="form-group">
    <fieldset className="inputs">
      <legend className={style.noMargin}>
        <span>Payment</span>
      </legend>
      <Row className="form-group">
        <Col md={8}>
          <FieldInput
            name="cardName"
            type="input"
            label="Full Name"
            hint="As it appears on the front of your card"
            className={style.largeStringInput}
          />
          <Row>
            <Col md={6}>
              <FieldInput
                name="cardNumber"
                type="input"
                label="Card Number"
                hint="As it appears on the front of your card"
              />
            </Col>
            <Col md={6}>
              <FieldInput
                name="cardCvc"
                type="input"
                label="Security Code"
                hint="3 digit code on the back of your card (4 digits on the front for American Express)"
                className={style.smallStringInput}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className={'u-margin-T-s'}>
                <ControlLabel>Expiration Date:</ControlLabel>
                <Row>
                  <Col xs={6} md={6}>
                    <Field className="form-control" name="cardExpirationDateMonth" component="select">
                      {months.map((month) => (
                        <option key={month} value={month} className="option">
                          {month}
                        </option>
                      ))}
                    </Field>
                  </Col>
                  <Col xs={6} md={6}>
                    <Field className="form-control" name="cardExpirationDateYear" component="select">
                      {years.map((year) => (
                        <option key={year} value={year} className="option">
                          {year}
                        </option>
                      ))}
                    </Field>
                  </Col>
                </Row>
                <div className={style.errorMessage}>
                  {errors.cardExpirationDate &&
                    errors.cardExpirationDate.map((errorMessage) => (
                      <span key={errorMessage}>{errorMessage}</span>
                    ))}
                </div>
              </div>
            </Col>

            <Col md={6}>
              <FieldInput
                name="cardZipCode"
                type="input"
                label="Billing ZIP"
                hint="Or Postal Code if you're not in the USA"
                className={style.smallStringInput}
              />
            </Col>
          </Row>
        </Col>
        <Col md={4} className={cx(style.paypalImage, 'hidden-sm hidden-xs')}>
          <a
            href="http://www.paypal.com/in/webapps/mpp/paypal-popup"
            target="_blank"
            rel="noopener noreferrer">
            <img
              alt="Secured by PayPal"
              src="https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/logo-center/9_bdg_secured_by_pp_2line.png"></img>
          </a>
        </Col>
      </Row>
    </fieldset>
  </div>
);

export default BulkPaymentFormGroup;
